import { useCallback } from 'react'

import { BUILD_ENVIRONMENTS } from '@src/config/constants'
import { CONFIG_REPORTING_SERVICES } from '@src/config/env'
import appData from '@src/quince-site-common/src/helpers/appData'
import useBearerFetch from './useBearerFetch'

const useReferralPoints = (email, enabled = true) => {
  const { fetchData, response } = useBearerFetch()

  const fetchReferrals = useCallback(() => {
    // Referral history is locale-gated; skip the referredCustomers call entirely when it won't be shown.
    if (!enabled) return
    if (!email) return
    const isReferralApiSupported = appData.environmentType !== BUILD_ENVIRONMENTS.STAGE
    // @i18n-ignore
    const url = `${CONFIG_REPORTING_SERVICES}/v2-referralEmails/referredCustomers`

    const options = {
      // @i18n-ignore
      method: 'POST',
      headers: {
        // @i18n-ignore
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ emailId: email }),
    }
    return isReferralApiSupported && fetchData(url, options)
  }, [email, enabled, fetchData])

  return {
    fetchReferrals,
    successfulReferrals: response?.successfulReferrals,
    invitedReferrals: response?.invitedReferrals,
  }
}

export default useReferralPoints
